export default {
  install (Vue, options) {
    let local = (name) => {
      return { name: '' + name }
    }

    Vue.prototype.$local = local
  }
}
